import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import InAppBrowserNotice from "@/components/InAppBrowserNotice";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import Contatti from "@/pages/Contatti";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <InAppBrowserNotice />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App grain-overlay">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/chi-sono" element={<PublicLayout><ChiSiamo /></PublicLayout>} />
            <Route path="/servizi" element={<PublicLayout><Servizi /></PublicLayout>} />
            <Route path="/contatti" element={<PublicLayout><Contatti /></PublicLayout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
